import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
    Box, Typography, Card, CardHeader, CardContent, CardMedia, Avatar, Pagination, Divider
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useParams } from "react-router-dom";
import contact_img from '~/assets/images/contact_img.png';
import logo from '~/assets/images/loGo.png';
import ArticleServices from '../services/ArticleServices';

const ArticleDetail = () => {
    const [article, setArticle] = useState({});
    const [relatedArticles, setRelatedArticles] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const { id } = useParams();

    const getArticleById = useCallback(async () => {
        if (!id) return;
        try {
            let response = await ArticleServices.getArticleDetail(id, 3, page);
            if (response) {
                setArticle(response.items[0].article);
                setRelatedArticles(response.items[0].relatedArticles);
                setTotalPage(Math.ceil(Number(response.totalCount) / Number(response.pageSize)));
            }
        } catch (error) {
            console.error("Lỗi khi lấy bài viết:", error);
        }
    }, [id, page]);

    useEffect(() => {
        getArticleById();
    }, [getArticleById]);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 200,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center'
                }}>
                NỘI DUNG BÀI VIẾT
            </Box>
            {article && article.filePath && (
                <Box sx={{ maxWidth: 'md', marginInline: 'auto', marginBlock: 6, p: 2 }}>
                    <Typography
                        variant='h4'
                        sx={{ fontWeight: "bold", color: "var(--primary)", textAlign: 'center', textTransform: 'uppercase' }}>
                        {article.name}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2, color: "var(--blue)" }}>
                        <Typography>Ngày đăng: {new Date(article.createdAt).toLocaleDateString()}</Typography>
                        <Typography>Lượt xem: {article.view}</Typography>
                    </Box>
                    <Divider sx={{ marginBlock: 4 }} />
                    <Box sx={{ width: '100%' }}>
                        <iframe
                            src={process.env.REACT_APP_API_BASE_URL + article.filePath}
                            title='detail'
                            frameBorder={5}
                            style={{ width: "100%", height: "100vh" }} />
                    </Box>

                </Box>

            )}
            {relatedArticles.length > 0 && (
                <Box sx={{ maxWidth: 'lg', marginInline: 'auto', marginBlock: 8, p: 2 }}>

                    <Typography
                        variant='h5'
                        sx={{ fontWeight: 'bold', color: "var(--primary)", textAlign: "center", mb: 4 }}>
                        MỘT SỐ NỘI DUNG LIÊN QUAN
                    </Typography>
                    <Grid container spacing={2}>
                        {relatedArticles.map((item, index) => (
                            <Grid key={index} size={{ md: 4, sm: 6, xs: 12 }}>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        height: 350,
                                        transition: "box-shadow 0.5s",
                                        "&:hover": {
                                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                        }
                                    }}>
                                    <CardHeader
                                        avatar={<Avatar src={logo} aria-label="recipe" />}
                                        title={
                                            <Typography sx={{ fontWeight: 'bold', color: 'var(--primary)' }}>
                                                Trung tâm ngoại ngữ và tin học
                                            </Typography>
                                        }
                                        subheader={
                                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between' }}>
                                                <Typography variant="body2">
                                                    {new Date(item.createdAt).toLocaleDateString()}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Lượt xem: {item.view}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                    <CardMedia
                                        sx={{ height: 200 }}
                                        image={process.env.REACT_APP_API_BASE_URL + item.image}
                                        alt={item.name} />
                                    <CardContent>
                                        <Link
                                            to={`/article-detail/${item.id}`}
                                            style={{ textDecoration: "none", color: "var(--primary)" }}
                                            className='link-blue'
                                            onClick={() => window.scrollTo({ top: 250 })}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 'bold',
                                                    fontSize: 20,
                                                    textAlign: 'center',
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 2,
                                                    overflow: 'hidden',
                                                }}>
                                                {item.name}
                                            </Typography>
                                        </Link>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {totalPage > 1 && (
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <Pagination count={totalPage} page={page} size="large" shape="rounded" color="primary" onChange={handlePageChange} />
                </Box>
            )}
        </Box>
    );
}

export default ArticleDetail;
